import { useSelector } from 'app-redux'
import { useEffect, useMemo, useState } from 'react'
import type { StageAudioOutput } from 'room/common/stage-audio-output'
import { resolveSink } from './model/speakers'
import { useAudioOutputs } from './use-audio-outputs'

export type ProjectorSpeakers = {
	/** What the recordings in this window are to play through. */
	output: StageAudioOutput
	/** The trainer's speakers cannot be used; the recordings play on the default. */
	fellBack: boolean
}

/**
 * The presentation window's audio output: the speakers the console chose
 * (`presenter.speakers`, replicated), while they are plugged in and the
 * browser accepts them - the system default otherwise. Plugging a device in
 * or out gives a refused one another try.
 */
export const useProjectorSpeakers = (): ProjectorSpeakers => {
	const chosen = useSelector(state => state.presenter.speakers)
	const { outputs } = useAudioOutputs()
	const [refused, setRefused] = useState<string | null>(null)
	useEffect(() => setRefused(null), [outputs])

	const { sinkId, unavailable } = resolveSink({ chosen, outputs, refused })
	const output = useMemo<StageAudioOutput>(
		() => ({ sinkId, onRefused: setRefused }),
		[sinkId]
	)
	return { output, fellBack: unavailable }
}
